<template>
    <div class="ai_task_dashboard_right_section">
        <div class="recent_pretrained_models_wrp">
            <h3 class="recent_pretrained_models_heading mb-4 text-center">Model Details</h3>
            <div class="model_details_inner_wrp" v-if="modelInfo">
                <ul>
                    <li>
                        <span class="model_details_key">Name :</span>
                        <span class="model_details_val"> {{ modelInfo.name }}</span>
                    </li>
                    <li>
                        <span class="model_details_key">Disease :</span>
                        <span class="model_details_val">
                            <template v-if="modelInfo.subDisease">{{ modelInfo.subDisease
                                }}</template>
                            <template v-else>{{ modelInfo.disease }}</template>
                        </span>
                    </li>
                    <li>
                        <span class="model_details_key">Algorithm :</span>
                        <span class="model_details_val"> {{ modelInfo.display_name_algorithm }}</span>
                    </li>
                    <li v-if="modelInfo.description">
                        <span class="model_details_key">Description :</span>
                        <span class="model_details_val" v-html="modelInfo.description"></span>
                    </li>
                    <li v-if="modelInfo.acc">
                        <span class="model_details_key">Accuracy :</span>
                        <span class="model_details_val"> {{ modelInfo.acc }} %</span>
                    </li>
                    <li v-if="modelInfo.rmse">
                        <span class="model_details_key">RMSE :</span>
                        <span class="model_details_val"> {{ modelInfo.rmse }}</span>
                    </li>
                    <li v-if="modelInfo.type_model == 'Regression'">
                        <p class="regression_txt_message">We cannot calculate accuracy for a regression model. Instead,
                            an error metric is
                            used to evaluate like RMSE (Root Mean Square Error).</p>
                    </li>
                    <li v-if="modelInfo.is_Specificity">
                        <span class="model_details_key">Specificity
                            <span class="tooltip_info_item">
                                <i class="fa fa-info-circle" aria-hidden="true"></i>
                                <span class="tooltip_info_txt">{{ modelInfo.specificity_description }}</span>
                            </span>
                            :</span>
                        <span class="model_details_val">{{ modelInfo.specificity }} %</span>
                    </li>
                    <li v-if="modelInfo.is_Sensitivity">
                        <span class="model_details_key">Sensitivity
                            <span class="tooltip_info_item">
                                <i class="fa fa-info-circle" aria-hidden="true"></i>
                                <span class="tooltip_info_txt">{{ modelInfo.sensitivity_description }}</span>
                            </span>
                            :</span>
                        <span class="model_details_val">{{ modelInfo.sensitivity }} %</span>
                    </li>
                    <li v-if="modelInfo.is_MCC">
                        <span class="model_details_key">MCC
                            <span class="tooltip_info_item">
                                <i class="fa fa-info-circle" aria-hidden="true"></i>
                                <span class="tooltip_info_txt">{{ modelInfo.mcc_description }}</span>
                            </span>
                            :</span>
                        <span class="model_details_val">{{ modelInfo.mcc }}</span>
                    </li>
                    <li v-if="modelInfo.is_MAE">
                        <span class="model_details_key">MAE
                            <span class="tooltip_info_item">
                                <i class="fa fa-info-circle" aria-hidden="true"></i>
                                <span class="tooltip_info_txt">{{ modelInfo.mae_description }}</span>
                            </span>
                            :</span>
                        <span class="model_details_val">{{ modelInfo.mae }}</span>
                    </li>
                    <li v-if="modelInfo.is_R_Square">
                        <span class="model_details_key">R Square
                            <span class="tooltip_info_item">
                                <i class="fa fa-info-circle" aria-hidden="true"></i>
                                <span class="tooltip_info_txt">{{ modelInfo.r_square_description }}</span>
                            </span>
                            :</span>
                        <span class="model_details_val">{{ modelInfo.r_square }}</span>
                    </li>
                    <!-- <li v-if="modelInfo.is_F1">
                        <span class="model_details_key">F1 Score
                            <span class="tooltip_info_item">
                                <i class="fa fa-info-circle" aria-hidden="true"></i>
                                <span class="tooltip_info_txt">{{ modelInfo.f1_description }}</span>
                            </span>
                            :</span>
                        <span class="model_details_val">{{ modelInfo.f1 }}</span>
                    </li>
                    <li v-if="modelInfo.is_Kappa">
                        <span class="model_details_key">Kappa
                            <span class="tooltip_info_item">
                                <i class="fa fa-info-circle" aria-hidden="true"></i>
                                <span class="tooltip_info_txt">{{ modelInfo.kappa_description }}</span>
                            </span>
                            :</span>
                        <span class="model_details_val">{{ modelInfo.kappa }}</span>
                    </li> -->
                </ul>
            </div>
            <div class="model_details_inner_wrp describe_list_info" v-if="labelDescList && labelDescListResult.length > 0">
                <ul>
                    <li v-for="item in labelDescListResult" :key="item.id">
                        <span class="model_details_key">{{ item.key }} : </span>
                        <span class="model_details_val"> {{ item.label }}</span>
                    </li>
                    <li v-if="labelDescListNext"><button class="btn btn-primary" :disabled="submitted"
                            v-on:click="nextDescribeListMethod(labelDescListNext)">Show More</button></li>
                </ul>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    props:['modelInfo'],
    data() {
        return {
            labelDescList: null,
            labelDescListResult:[],
            labelDescListNext: []
        }
    },
    mounted() {
        if(this.modelInfo && this.modelInfo.is_public){
            this.$store.dispatch('getAttrOfTrainedForUseModelsFun', { id: this.$route.params.useModelsId }).then((res) => {
                this.labelDescList = res.data.data
                this.labelDescListResult = this.labelDescList.results
                this.labelDescListNext = this.labelDescList.next
            })
        }
    }
}
</script>
<style lang="scss" scoped>
.ai_task_dashboard_right_section {
    background: rgba(0,0,0,.75);
    box-shadow:-5px 5px 10px rgba(138, 145, 153, 0.06);
    padding: 15px 20px;
    border-radius: 4px;
    height: 100%;
    min-height: calc(100dvh - 100px);
    @media only screen and (max-width:769px){
        min-height:inherit;
    }
    .tooltip_info_item{
        display:inline-block;
        margin-left:0px;
        vertical-align:baseline;
        position: relative;
        .fa-info-circle{color:#ffffff;cursor: pointer;font-size:14px;}
        .tooltip_info_txt{
            right: calc(100% + 8px);
            position: absolute;
            background: #ffdee3;
            padding: 3px 4px;
            cursor: default;
            z-index: 999;
            font-weight: 600;
            line-height: 1.3;
            font-family: -apple-system,BlinkMacSystemFont,Segoe UI,Helvetica Neue,Arial,sans-serif,Apple Color Emoji,Segoe UI Emoji,Segoe UI Symbol,Noto Color emoji;
            font-size: 14px !important;
            color: #000;
            top: 0;
            border-radius: 2px;
            width: calc(100% + 30vw);
            display: none; 
            text-align: center;
            @media only screen and (max-width:767px){
            right: auto;
            left: calc(100% + 8px); 
            width:calc(100% + 50vw);
            }
            &:before{    
                border: solid;
                border-color: #ffdee3 transparent;
                border-width: 0px 0px 12px 12px;
                top: 6.5px;
                content: "";
                display: block;
                right: -5px;
                position: absolute;
                z-index: 1000;
                -webkit-transform: rotate(315deg);
                transform: rotate(315deg);
                @media only screen and (max-width:767px){
                right: auto;
                border-width: 12px 12px 0px 0px;
                left: -5px;
                }
            }
        }
        &:hover .tooltip_info_txt{display:block;}
    }
}
</style>